import { Pipe, PipeTransform } from '@angular/core';
import { ILinkUp } from '@pdqdev/pdq-shared/dist/interfaces/ILinkUp';

@Pipe({
  name: 'deviceIcon',
  standalone: false,
})
export class DeviceIconPipe implements PipeTransform {
  transform(deviceType: ILinkUp.DeviceType): string {
    switch (deviceType) {
      case ILinkUp.DeviceType.PRINTER:
        return 'printer';
    }
  }
}
